import { NAME as USER_NAME } from '../constants';
export const NAME = `${USER_NAME}/brandReview` as const;

export const PROMPT_TIMEOUT = 60 * 60 * 1000;
export const MAX_PROMPTS = 3;
export const MINIMUM_VALID_CONVERSATIONS = 5;
